import * as Yup from 'yup';

export const scheduledMessagesTabFiltersSchema = () =>
  Yup.object({
    from: Yup.date().nullable(),
    propertyUid: Yup.array()
      .of(Yup.object({ label: Yup.string(), value: Yup.string() }))
      .nullable(),
    sentVia: Yup.array()
      .of(Yup.object({ label: Yup.string(), value: Yup.string() }))
      .nullable(),
    status: Yup.array()
      .of(Yup.object({ label: Yup.string(), value: Yup.string() }))
      .nullable(),
    to: Yup.date().nullable(),
  });

export type ScheduledMessagesTabFiltersSchemaType = Yup.InferType<
  ReturnType<typeof scheduledMessagesTabFiltersSchema>
>;

export const getFormDefaultValues =
  (): ScheduledMessagesTabFiltersSchemaType => {
    return {
      from: null,
      propertyUid: [],
      sentVia: [],
      status: [],
      to: null,
    };
  };
